import { TemplateResult, html, CSSResultGroup } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './idb-form-confirmation-page.css.lit';
import { OutlineElement } from 'src/components/base/outline-element/outline-element';
import { SlotController } from '../../controllers/slot-controller';

/**
 * The IdbFormConfirmationPage component
 * @element idb-form-confirmation-page
 * @slot content - HTML content.
 * @todo update with slots as needed
 */
@customElement('idb-form-confirmation-page')
export class IdbFormConfirmationPage extends OutlineElement {
  slots = new SlotController(
    this, // This, the host element.
    true // To shift or not to shift LightDom nodes to ShadowDOM.
  );
  static styles: CSSResultGroup = [componentStyles];

  /**
   * Let's you set the title weight.
   */
  @property({ type: String, attribute: 'icon-name' })
  iconName: '';

  render(): TemplateResult {
    const classes = {
      'idb-form-confirmation-page': true,
    };

    return html`
    <div class=${classMap(classes)}>
      <outline-icon library="iconoir" name="${
        this.iconName
      }" class="mr-2" size="12rem"></outline-icon>
      <slot name="content"></slot>
    </div>`;
  }
}
